var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdminActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24-admin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 6.70944C5.25 11.3932 6.81716 14.9808 8.43056 16.8631C10.044 18.7454 12 19.5625 12 19.5625C12 19.5625 13.956 18.7454 15.5694 16.8631C17.1828 14.9808 18.75 11.3932 18.75 6.70944L12 4.45944L5.25 6.70944ZM12 6.04058L6.75755 7.78806C6.87089 11.7925 8.24138 14.3375 9.56944 15.8869C10.2678 16.7017 12 17.9123 12 17.9123C12 17.9123 13.7322 16.7017 14.4306 15.8869C15.7586 14.3375 17.1291 11.7925 17.2425 7.78806L12 6.04058Z",
    fill: "#19252E",
    stroke: "black",
    strokeWidth: 0.4
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdminActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/admin_active.9bcab341f84c30dce5b284b3566339f8.svg";